module.exports = __webpack_public_path__ + "242e1d358c773c55843579fe56b186cd.png";